import React from "react";
import { Loja } from "../../../../types/loja";

interface LojaSelectorProps {
  lojas: Loja[];
  selectedLojaId?: number;
  showLojaSelector: boolean;
  onSelectAllLojas?: () => void;
  onSelectLoja?: (id: number) => void;
}

export const LojaSelector: React.FC<LojaSelectorProps> = ({
  lojas,
  selectedLojaId,
  showLojaSelector,
  onSelectAllLojas,
  onSelectLoja,
}) => {
  if (!showLojaSelector || lojas.length === 0) {
    return null;
  }

  return (
    <div className="fixed left-2 top-14 z-40 min-w-44 rounded-lg bg-black/80 p-3 backdrop-blur-sm sm:left-4 sm:top-16 sm:min-w-48 sm:p-4">
      <h3 className="mb-2 font-semibold text-white">Selecionar Loja:</h3>
      <div className="space-y-1">
        <button
          type="button"
          onClick={onSelectAllLojas}
          className={`w-full rounded px-3 py-2 text-left text-sm transition-colors ${
            !selectedLojaId
              ? "bg-cyan-600 text-white"
              : "bg-white/10 text-white hover:bg-white/20"
          }`}
        >
          Todas as Lojas
        </button>
        {lojas.map((loja) => (
          <button
            key={loja.id}
            type="button"
            onClick={() => onSelectLoja?.(loja.id)}
            className={`w-full rounded px-3 py-2 text-left text-sm transition-colors ${
              selectedLojaId === loja.id
                ? "bg-cyan-600 text-white"
                : "bg-white/10 text-white hover:bg-white/20"
            }`}
          >
            {loja.nome}
          </button>
        ))}
      </div>
    </div>
  );
};
